import { Benefit } from '../types/insurance-report-api.types';

export const isMatch = (
  value: string | string[] | number | boolean | null | undefined,
  searchTerm: string
): boolean => {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)?.toLowerCase()?.includes(searchTerm);
  }
  if (typeof value === 'string') {
    return value?.toLowerCase()?.includes(searchTerm);
  }
  if (Array.isArray(value)) {
    return value.some((item) => {
      if (item === null || item === undefined) return false;
      return String(item)?.toLowerCase()?.includes(searchTerm);
    });
  }

  return false;
};

export const getSearchDataOfFrequencyAndLimitations = (
  data: Record<string, Benefit[]>,
  searchTerm: string
): Record<string, Benefit[]> => {
  if (!searchTerm) return data;

  searchTerm = searchTerm.toLowerCase();

  const result: Record<string, Benefit[]> = {};

  for (const [category, items] of Object.entries(data || {})) {
    const filteredItems = items.filter((item) => Object.values(item).some((val) => isMatch(val, searchTerm)));

    if (filteredItems.length > 0) {
      result[category] = filteredItems;
    }
  }

  return result;
};

export const getSearchDataOffavoriteAndRequestedCDTCodes = (
  data: Record<string, Benefit[]>,
  searchTerm: string
): Record<string, Benefit[]> => {
  if (!searchTerm) return data;
  searchTerm = searchTerm.toLowerCase();
  const result: Record<string, Benefit[]> = {};
  for (const [network, items] of Object.entries(data || {})) {
    const filteredItems = items.filter((item) => Object.values(item).some((val) => isMatch(val, searchTerm)));
    if (filteredItems.length > 0) {
      result[network] = filteredItems;
    }
  }
  return result;
};
